module.exports = "https://web-assets-production.autolist.com/_next/static/images/online-delivery-6b68a870750bf769cc48f0648f005c79.png";